import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { findTimeSerie } from 'src/app/models/graphQL/graphql-ts-graphQL.request'
import { LoginService } from 'src/app/services/login/login.service';
import { Apollo } from 'apollo-angular';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';
import moment from 'moment-timezone';



@Component({
  selector: 'app-graphql-ts',
  templateUrl: './graphql-ts.component.html',
  styleUrls: ['./graphql-ts.component.scss']
})
export class GraphqlTsComponent implements OnChanges {


  title: string;
  @Input() graphConfig: any;
  graph: any;
  loading: boolean = true

  constructor(private apollo: Apollo,
    private loginService: LoginService) { }


  ngOnChanges() {
    this.apollo.watchQuery<any>({
      query: findTimeSerie,
      variables: {
        dispositivo: this.graphConfig.dispositivos,
        from: this.graphConfig.from,
        to: this.graphConfig.to,
        limit: this.graphConfig.limit,
        tipoDato: this.graphConfig.tipoDato
      },
      fetchPolicy: 'network-only'
    }).valueChanges
      .pipe(
        map(response => response.data.findTimeSerie)
      ).subscribe(data => {
        let dataArray: any[] = [];
        this.graph = {
          data: [],
          layout: this.graphConfig.layout,
          config: {
            displayModeBar: false,
            responsive: true
          }
        };
        //this.graph.layout.title = this.title;
        let grouped = _.groupBy(data, item => {
          return item.dispositivo + item.tipoDato;
        });
        for (let i = 0; i < Object.keys(grouped).length; i++) {
          dataArray.push({
            x: this.getDatesToString(grouped[Object.keys(grouped)[i]].map(r => r.fecha)),
            y: grouped[Object.keys(grouped)[i]].map(r => r.valor), 
            name: this.graphConfig.tipoDatoName? this.graphConfig.tipoDatoName[i] : null,
            type: this.graphConfig.type, 
            mode: this.graphConfig.mode
          })
        };
        for (let elem of dataArray) {
          this.graph.data.push(elem)
        }
        this.loading = false;
      })
  }


  getDatesToString(date: number[]): string[] {
    let dateAux: string[] = [];

    const timezone = this.loginService.currentUserValue.timeZone
    for (let elem of date) {
      dateAux.push(moment.unix(elem / Math.pow(10, 9)).tz(timezone).format('YYYY-MM-DD HH:mm:ss'))
    }
    return dateAux;
  }


}
